/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PrincipalRolesControllerUpdateMutationRequest, PrincipalRolesControllerUpdateMutationResponse, PrincipalRolesControllerUpdatePathParams, PrincipalRolesControllerUpdate400, PrincipalRolesControllerUpdate401, PrincipalRolesControllerUpdate403, PrincipalRolesControllerUpdate404, PrincipalRolesControllerUpdate409 } from "../../models/principalRolesController/PrincipalRolesControllerUpdate";

function getPrincipalRolesControllerUpdateUrl(id: PrincipalRolesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/principal-roles/${id}` as const }  
  return res
}

/**
 * @summary Update a principal role assignment
 * {@link /api/v1/principal-roles/:id}
 */
export async function principalRolesControllerUpdate(id: PrincipalRolesControllerUpdatePathParams["id"], data?: PrincipalRolesControllerUpdateMutationRequest, config: Partial<RequestConfig<PrincipalRolesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PrincipalRolesControllerUpdateMutationResponse, ResponseErrorConfig<PrincipalRolesControllerUpdate400 | PrincipalRolesControllerUpdate401 | PrincipalRolesControllerUpdate403 | PrincipalRolesControllerUpdate404 | PrincipalRolesControllerUpdate409>, PrincipalRolesControllerUpdateMutationRequest>({ method : "PATCH", url : getPrincipalRolesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}